import React from 'react';
import { useSelector } from 'react-redux';

import Table from 'components/Table';

import { getPValue } from 'utilities';
import { round6 } from 'utilities/math';

import { ITALIC_P } from 'scenes/InferentialStatistics/Constants';

import {
  getAltHypotesisSign,
  getH0,
  getH1,
  getTableData,
  getIsGroupChosen,
  getPValue as getPValueFromStore,
  getTStatistics,
  getStandardError,
  getDfValue,
  getPopulationProportionCommon

} from 'store/scenes/inferentialStatistics/selectors';

import { tableHeadersTwoSampleProportion } from '../shared';

const TwoProportionHypothesis = () => {
  const altHypothesisSign = useSelector(state => getAltHypotesisSign(state));
  const h0 = useSelector(state => getH0(state));
  const h1 = useSelector(state => getH1(state));
  const tableData = useSelector(state => getTableData(state));
  const tStatistics = useSelector(state => getTStatistics(state));
  const pValue = useSelector(state => getPValueFromStore(state));
  const standardError = useSelector(state => getStandardError(state));
  const dfValue = useSelector(state => getDfValue(state));
  const populationProportionCommon = useSelector(state => getPopulationProportionCommon(state));
  const isGroupChosen = useSelector(state => getIsGroupChosen(state));

  const tableHeaders = tableHeadersTwoSampleProportion(isGroupChosen);

  return (
    <div className="content-item">
      <h3 className="mb-20">Two Sample Proportion Hypothesis Test Summary</h3>
      <div className="mb-5 pl-5">
        <p className="font-900 font-16 mb-5">{ITALIC_P}<sub>1</sub>: proportion of successes in population 1</p>
        <p className="font-900 font-16 ">{ITALIC_P}<sub>2</sub>: proportion of successes in population 2</p>
      </div>
      <table className="infStatMarkup-table">
        <tbody>
          <tr>
            <td>Null Hypothesis</td>
            <td>
              <span className="font-900 font-16 mb-10 mr-5">
                H<sub>0</sub>: {ITALIC_P}<sub>1</sub> - {ITALIC_P}<sub>2</sub> =
              </span>
              <span>{round6(h0)}</span>
            </td>
          </tr>
          <tr>
            <td className="pb-20">Alternative Hypothesis</td>
            <td className="pb-20">
              <span className="font-900 font-16 mb-10 mr-5">
                H<sub>1</sub>: {ITALIC_P}<sub>1</sub> - {ITALIC_P}<sub>2</sub> {altHypothesisSign}
              </span>
              <span>{round6(h1)}</span>
            </td>
          </tr>
          <tr>
            <td>Difference of Proportion</td>
            <td>
              <span>{round6(dfValue)}</span>
            </td>
          </tr>
          <tr>
            <td>Common p̂</td>
            <td>
              <span>{round6(populationProportionCommon)}</span>
            </td>
          </tr>
          <tr>
            <td>Standard Error</td>
            <td>
              <span>{round6(standardError)}</span>
            </td>
          </tr>
          <tr>
            <td>Z-Statistic</td>
            <td>
              <span>{round6(tStatistics)}</span>
            </td>
          </tr>
          <tr>
            <td>P-Value</td>
            <td>
              <span>{getPValue(pValue)}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <h3>Descriptive Statistics of Sample</h3>
      <Table tableHeaders={tableHeaders} tableData={tableData} />
    </div>
  );
};

export default TwoProportionHypothesis;
